import { useTranslation } from 'react-i18next';
import { generatePath } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';

import type { DashboardResultOverview } from 'src/types/dashboard';
import { apiPaths } from 'src/services/api/apiPaths';
import HttpService from 'src/services/api/http';

const useDashboardResults = (survey: number, enabled?: boolean) => {
  const { i18n } = useTranslation();
  const endPoint = generatePath(apiPaths.DASHBOARD.WIDGET_RESULTS, {
    surveyId: survey,
  });

  return useQuery({
    queryKey: [endPoint, i18n.language, survey],
    staleTime: 5 * 60 * 1000, // 5 min
    enabled: !!enabled,
    queryFn: ({ signal }) =>
      HttpService.get(endPoint, undefined, false, { signal }).then(
        ({ data }: { data: DashboardResultOverview }) => data,
      ),
  });
};

export default useDashboardResults;
